<template>
    <v-dialog v-model="visible" max-width="600" persistent>
        <v-card v-if="survey">
            <v-card-title>Evaluación de la reunión: {{ survey.nombre_reunion }}</v-card-title>
            <v-card-subtitle>
                Apóyenos valorando el NPS de la reunión del día {{ survey.fecha_reunion }} presionando las estrellas
            </v-card-subtitle>
            <v-card-text class="text-center">
                <v-rating v-model="form.valor" length="10" color="orange" empty-icon="mdi-star-outline"
                    full-icon="mdi-star"></v-rating>
                <div class="mt-2 font-weight-bold">Puntuación: {{ form.valor }} / 10</div>
                <div class="text-left body-2 grey--text text--darken-1 mb-2">
                    Permítenos seguir mejorando la experiencia con tus comentarios y/o sugerencias de la sesión llevada
                    a cabo:
                </div>
                <v-textarea v-model="form.comentario" label="Escribe tus comentarios aquí...(Opcional)" outlined
                    rows="3" counter="500" auto-grow></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!survey.es_externo" text @click="cerrar">Cancelar</v-btn>
                <v-btn color="green" class="white--text" :disabled="!form.valor || loading" :loading="loading"
                    @click="enviar">
                    Enviar respuesta
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: Boolean,
        survey: Object 
    },
    data() {
        return {
            loading: false,
            form: {
                valor: 0,
                comentario: '',
                minuta_id: null,
                encuesta_id: null,
                cliente: null
            }
        }
    },
    computed: {
        visible: {
            get() { return this.value },
            set(val) { this.$emit('input', val) }
        }
    },
    mounted() {
        if (this.survey) {
            this.cargarDatosFormulario();
        }
    },
    watch: {
        value(val) {
            if (val && this.survey) {
                this.cargarDatosFormulario();
            }

        }
    },
    methods: {
        cargarDatosFormulario() {
            this.form.valor = 0;
            this.form.comentario = '';
            this.form.minuta_id = this.survey.id_minuta;
            this.form.encuesta_id = this.survey.id;
            
            if (this.survey.es_externo || this.survey.cliente_id) {
                this.form.cliente = this.survey.cliente_id;
            } else {
                this.form.cliente = this.$store.state.id;
            }
        },
        cerrar() {
            this.visible = false;
        },
        async enviar() {
            this.loading = true;
            try {
                await this.$axios.post('sendAnswer', this.form);
                this.$emit('success');
                this.cerrar();
            } catch (error) {
                console.error('Error al enviar respuesta', error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>